import React, { FunctionComponent, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IIconProps } from "../../../../assets/icons/icon";

export const NutrientIndicatorExplanationHeroMobile: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;

  const translator = useTranslation().t;
  const t = useCallback((key: string) => translator(`micronutrient.explanation.hero.${key}`), [translator]);

  return (
    <svg
      viewBox="0 0 352 735"
      preserveAspectRatio="xMidYMid meet"
      {...rest}
      style={{ ...rest.style, textRendering: "geometricPrecision" }}
    >
      <defs>
        <rect
          id="path-mobile-nutrient-explanation"
          x="1.42108547e-14"
          y="0"
          width="323.060241"
          height="210"
          rx="16"
        ></rect>
        <rect id="path-mobile-nutrient-explanation-3" x="0" y="0" width="132" height="6" rx="3"></rect>
        <rect id="path-mobile-nutrient-explanation-5" x="0" y="0" width="44" height="735"></rect>
      </defs>
      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Mobile-11a-Mikronährstoffe" transform="translate(0.000000, -663.000000)">
          <g id="Card" transform="translate(0.000000, 554.000000)">
            <g id="Group-4" transform="translate(0.000000, 109.000000)">
              <g id="UI-Elements/Card/Nährstoffe" transform="translate(25.969880, 106.000000)">
                <mask id="mask-2" fill="white">
                  <use href="#path-mobile-nutrient-explanation"></use>
                </mask>
                <rect stroke="#82BECC" strokeWidth="2" x="-1" y="-1" width="325.060241" height="212" rx="16"></rect>
                <g id="Icons/Base/Info" mask="url(#mask-2)">
                  <g transform="translate(284.030120, 9.000000)" id="Group">
                    <circle id="Oval" fill="#FFFFFF" cx="14" cy="14" r="14"></circle>
                    <circle
                      id="Oval"
                      stroke="#222222"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      cx="14"
                      cy="14"
                      r="8"
                    ></circle>
                    <path
                      d="M14.91,11.61 L14.91,10 L13.05,10 L13.05,11.61 L14.91,11.61 Z M14.91,17.88 L14.91,12.8 L13.07,12.8 L13.07,17.88 L14.91,17.88 Z"
                      id="i"
                      fill="#222222"
                      fillRule="nonzero"
                    ></path>
                  </g>
                </g>
                <g id="Infos" mask="url(#mask-2)">
                  <g transform="translate(18.030120, 16.000000)">
                    <text
                      id="Vitamin-B1"
                      fontFamily="Navigo-Bold, Navigo"
                      fontSize="18"
                      fontWeight="bold"
                      line-spacing="22"
                    >
                      <tspan x="0" y="18" fill="#222222">
                        {t("card.header")}
                      </tspan>
                    </text>
                    <g id="Funktion" strokeWidth="1" fillRule="evenodd" transform="translate(1.166667, 22.000000)">
                      <text
                        id="Abbau-von-Fettsäuren"
                        fontFamily="Navigo-Light, Navigo"
                        fontSize="16"
                        fontWeight="300"
                        line-spacing="23"
                        fill="#222222"
                      >
                        <tspan x="19" y="19">
                          {t("card.line_1")}
                        </tspan>
                      </text>
                      <g
                        id="Icons/Base/Others/Ernährung-Copy"
                        transform="translate(-0.000000, 7.166667)"
                        stroke="#222222"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.16666667"
                      >
                        <g id="Group" transform="translate(1.166667, 1.166667)">
                          <path
                            d="M11.297522,1.59335998 L9.5607876,3.32964874 L8.33664378,3.32964874 L8.33664378,2.10544997 L10.0728546,0.368637608 C8.97452855,-0.231316273 7.61964169,-0.0894739409 6.66937235,0.724946223 C5.71910302,1.53936639 5.37150521,2.8566239 5.79620501,4.03390337 L0.38075609,9.4475009 C0.0523736227,9.77589811 -0.0758743297,10.2545475 0.0443219956,10.7031464 C0.164518321,11.1517453 0.514898243,11.502141 0.963477036,11.6223427 C1.41205583,11.7425444 1.8906837,11.6142907 2.21906617,11.2858935 L7.63294433,5.86967791 C8.81017097,6.29439677 10.1273694,5.94678336 10.941753,4.99647138 C11.7561366,4.04615939 11.8979726,2.69121172 11.2980456,1.59283637 L11.297522,1.59335998 Z"
                            id="Path"
                          ></path>
                        </g>
                      </g>
                    </g>
                    <g id="Vorkommen" strokeWidth="1" fillRule="evenodd" transform="translate(1.166667, 44.000000)">
                      <text
                        id="Fleisch,-Fisch,-Eier"
                        fontFamily="Navigo-Light, Navigo"
                        fontSize="16"
                        fontWeight="300"
                        line-spacing="23"
                        fill="#222222"
                      >
                        <tspan x="19" y="19">
                          {t("card.line_2")}
                        </tspan>
                      </text>
                      <text
                        id="1.200-mg-(Ø-800-mg)"
                        fontFamily="Navigo-Light, Navigo"
                        fontSize="16"
                        fontWeight="300"
                        line-spacing="23"
                        fill="#222222"
                      >
                        <tspan x="17.8333333" y="43">
                          {t("card.line_3")}
                        </tspan>
                      </text>
                      <g
                        id="Icons/Base/Others/Ernährung"
                        transform="translate(-0.000000, 7.750000)"
                        stroke="#222222"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.16666667"
                      >
                        <path
                          d="M10.2694445,1.60120564 C9.63696596,1.42053337 8.95420622,1.56961395 8.45962022,1.99638076 C8.15215938,0.821496823 7.0724074,0 5.83563432,0 C4.59886125,0 3.51910927,0.821496823 3.21164842,1.99638076 C2.70718118,1.56395444 2.01067058,1.41793183 1.37002588,1.61028679 C0.729381177,1.80264176 0.235595091,2.30605355 0.0644210696,2.94134263 C-0.0895932836,3.5141316 0.0359764396,4.12458603 0.404373396,4.59401335 C0.772770352,5.06344067 1.34232877,5.33874853 1.94632716,5.33934867 C2.07756714,5.33437051 2.20791796,5.31596135 2.33525788,5.28442085 L2.33525788,9.73711367 C2.33525788,10.1584442 2.6835183,10.5 3.11311931,10.5 L8.55814934,10.5 C8.98775034,10.5 9.33601077,10.1584442 9.33601077,9.73711367 L9.33601077,5.28442085 C9.46335801,5.31592501 9.59370494,5.33433362 9.72494148,5.33934867 C10.691586,5.33759088 11.5102526,4.63992895 11.6469571,3.7014205 C11.7836615,2.76291205 11.1969214,1.86834294 10.2694445,1.60120564 Z"
                          id="Path"
                        ></path>
                        <line x1="6.89830225" y1="8.58067324" x2="6.89830225" y2="6.24025099" id="Path"></line>
                        <line x1="4.7770905" y1="8.58067324" x2="4.7770905" y2="6.24025099" id="Path-Copy"></line>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Werte" mask="url(#mask-2)">
                  <g transform="translate(-1.969880, 46.000000)">
                    <rect id="Mask-Copy" fill="#F6F6F6" x="0" y="82" width="325.03012" height="82"></rect>
                    <g id="Bedarf-Genetik" strokeWidth="1" fill="none" transform="translate(20.000000, 0.000000)">
                      <text
                        id="Veranlagung"
                        fontFamily="Navigo-Bold, Navigo"
                        fontSize="14"
                        fontWeight="bold"
                        fill="#222222"
                      >
                        <tspan x="0" y="108">
                          {t("card.bottom_line_1")}
                        </tspan>
                      </text>
                      <text
                        id="Erhöhter-Bedarf"
                        fontFamily="Navigo-Light, Navigo"
                        fontSize="14"
                        fontWeight="300"
                        line-spacing="19"
                        fill="#222222"
                      >
                        <tspan x="0" y="126">
                          {t("card.bottom_line_2")}
                        </tspan>
                      </text>
                      <g id="UI-Elements/Level-Bar/3-von-5-Copy-2" transform="translate(0.000000, 140.000000)">
                        <mask id="mask-4" fill="white">
                          <use href="#path-mobile-nutrient-explanation-3"></use>
                        </mask>
                        <g id="BG"></g>
                        <g id="Group" mask="url(#mask-4)" fill="#82BECC">
                          <rect id="Rectangle" x="0" y="0" width="24" height="6"></rect>
                          <rect id="Rectangle-Copy" x="27" y="0" width="24" height="6"></rect>
                          <rect id="Rectangle-Copy-2" x="54" y="0" width="24" height="6"></rect>
                          <rect id="Rectangle-Copy-3" x="81" y="0" width="24" height="6"></rect>
                          <rect id="Rectangle-Copy-5" x="108" y="0" width="24" height="6"></rect>
                        </g>
                      </g>
                    </g>
                    <g id="Blutanalyse" strokeWidth="1" fill="none" transform="translate(173.030120, 92.000000)">
                      <text
                        id="Aktueller-Wert"
                        fontFamily="Navigo-Bold, Navigo"
                        fontSize="14"
                        fontWeight="bold"
                        fill="#222222"
                      >
                        <tspan x="0" y="16">
                          {t("card.bottom_line_3")}
                        </tspan>
                      </text>
                      <text
                        id="Leichter-Mangel"
                        fontFamily="Navigo-Light, Navigo"
                        fontSize="14"
                        fontWeight="300"
                        line-spacing="19"
                        fill="#222222"
                      >
                        <tspan x="0" y="34">
                          {t("card.bottom_line_4")}
                        </tspan>
                      </text>
                      <g id="UI-Elements/Level-Bar/3-von-5-Copy" transform="translate(0.000000, 46.000000)">
                        <rect id="Rectangle" fill="#D2D2D2" x="0" y="2" width="132" height="6" rx="3"></rect>
                        <rect
                          id="Rectangle-Copy-2"
                          fill="#911B58"
                          x="0"
                          y="2"
                          width="39.1111111"
                          height="6"
                          rx="3"
                        ></rect>
                        <circle
                          id="Oval-Copy"
                          stroke="#F6F6F6"
                          strokeWidth="2"
                          fill="#D2D2D2"
                          cx="72.0555556"
                          cy="5"
                          r="6"
                        ></circle>
                        <circle
                          id="Oval"
                          stroke="#F6F6F6"
                          strokeWidth="2"
                          fill="#911B58"
                          cx="37.0555556"
                          cy="5"
                          r="6"
                        ></circle>
                      </g>
                      <g id="Icons/Level/Medium-Copy" transform="translate(116.000000, 20.000000)">
                        <circle id="Oval" fill="#911B58" cx="8" cy="8" r="8"></circle>
                        <g
                          id="Group"
                          transform="translate(8.300000, 8.193001) scale(1, -1) translate(-8.300000, -8.193001) translate(5.000000, 5.000000)"
                          stroke="#FFFFFF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                        >
                          <path
                            d="M4.62032593,0.977777778 C4.62459259,1.06145185 4.62032593,1.26222222 4.62032593,1.34613333 C4.62908487,3.96003315 3.54937021,6.89439832 0,6.31111111"
                            id="Path"
                          ></path>
                          <polyline id="Path" points="2.6 2 4.6 0 6.6 2"></polyline>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="Icons/Base/Others/Ernährung-Card"
                  mask="url(#mask-2)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g transform="translate(20.655120, 91.166667)" id="Group">
                    <line
                      x1="1.59090909"
                      y1="0"
                      x2="1.59090909"
                      y2="11.6666667"
                      id="Path"
                      stroke="#222222"
                      strokeWidth="1.16666667"
                    ></line>
                    <path
                      d="M3.18181818,0 L3.18181818,3.5 C3.17919732,4.3580459 2.46845603,5.05299293 1.59090909,5.05555556 L1.59090909,5.05555556 C0.713362152,5.05299293 0.00262086452,4.3580459 0,3.5 L0,0"
                      id="Path"
                      stroke="#222222"
                      strokeWidth="1.16666667"
                    ></path>
                    <line
                      x1="7.15909091"
                      y1="5.05555556"
                      x2="7.15909091"
                      y2="11.6666667"
                      id="Path"
                      stroke="#222222"
                      strokeWidth="1.16666667"
                    ></line>
                    <rect
                      id="Rectangle"
                      stroke="#222222"
                      strokeWidth="1.16666667"
                      x="5.56818182"
                      y="0"
                      width="3.18181818"
                      height="5.05555556"
                      rx="1.03703704"
                    ></rect>
                  </g>
                </g>
              </g>
              <text
                id="Deine-Genanalyse-zei"
                fontFamily="Navigo-Light, Navigo"
                fontSize="14"
                fontWeight="300"
                line-spacing="19"
                fill="#222222"
              >
                <tspan x="44" y="342">
                  {t("mobile_descriptions.top_left.line_1")}
                </tspan>
                <tspan x="44" y="361">
                  {t("mobile_descriptions.top_left.line_2")}
                </tspan>
                <tspan x="44" y="380">
                  {t("mobile_descriptions.top_left.line_3")}
                </tspan>
                <tspan x="44" y="399">
                  {t("mobile_descriptions.top_left.line_4")}
                </tspan>
                <tspan x="44" y="418">
                  {t("mobile_descriptions.top_left.line_5")}
                </tspan>
                <tspan x="44" y="437">
                  {t("mobile_descriptions.top_left.line_6")}
                </tspan>
              </text>
              <g id="Group-2" transform="translate(44.000000, 461.000000)">
                <text
                  id="Hier-erfährst-du-von"
                  fontFamily="Navigo-Light, Navigo"
                  fontSize="14"
                  fontWeight="300"
                  line-spacing="19"
                  fill="#222222"
                >
                  <tspan
                    x="0"
                    y="137"
                    dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.bottom_1.line_1") }}
                  ></tspan>
                  <tspan
                    x="0"
                    y="156"
                    dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.bottom_1.line_2") }}
                  ></tspan>
                  <tspan
                    x="0"
                    y="175"
                    dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.bottom_1.line_3") }}
                  ></tspan>
                </text>
                <text
                  id="Dein-persönlicher-Ta"
                  fontFamily="Navigo-Light, Navigo"
                  fontSize="14"
                  fontWeight="300"
                  line-spacing="19"
                  fill="#222222"
                >
                  <tspan
                    x="0"
                    y="219"
                    dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.bottom_2.line_1") }}
                  ></tspan>
                  <tspan
                    x="0"
                    y="238"
                    dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.bottom_2.line_2") }}
                  ></tspan>
                  <tspan
                    x="0"
                    y="257"
                    dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.bottom_2.line_3") }}
                  ></tspan>
                </text>
                <g
                  id="Icons/Base/Others/Ernährung-Card"
                  transform={`translate(${t("mobile_descriptions.bottom_2.cutlery_x")}, ${t(
                    "mobile_descriptions.bottom_2.cutlery_y",
                  )})`}
                  stroke="#222222"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g id="Group">
                    <line x1="1.36363636" y1="0" x2="1.36363636" y2="10" id="Path"></line>
                    <path
                      d="M2.72727273,0 L2.72727273,3 C2.72502627,3.73546791 2.11581945,4.3311368 1.36363636,4.33333333 L1.36363636,4.33333333 C0.611453273,4.3311368 0.0022464553,3.73546791 0,3 L0,0"
                      id="Path"
                    ></path>
                    <line x1="6.13636364" y1="4.33333333" x2="6.13636364" y2="10" id="Path"></line>
                    <rect
                      id="Rectangle"
                      x="4.77272727"
                      y="0"
                      width="2.72727273"
                      height="4.33333333"
                      rx="0.888888889"
                    ></rect>
                  </g>
                </g>
                <text
                  id="*-Basierend-auf-den"
                  fontFamily="Navigo-Light, Navigo"
                  fontSize="12"
                  fontWeight="300"
                  fill="#222222"
                >
                  <tspan x="0" y="14">
                    {t("mobile_descriptions.middle_left.line_1")}
                  </tspan>
                  <tspan x="0" y="31">
                    {t("mobile_descriptions.middle_left.line_2")}
                  </tspan>
                  <tspan x="0" y="48">
                    {t("mobile_descriptions.middle_left.line_3")}
                  </tspan>
                  <tspan x="0" y="65">
                    {t("mobile_descriptions.middle_left.line_4")}
                  </tspan>
                </text>
                <g
                  id="Overrides/Icons/Others/Ernährung-Copy"
                  transform={`translate(${t("mobile_descriptions.bottom_1.wrench_x")}, ${t(
                    "mobile_descriptions.bottom_1.wrench_y",
                  )})`}
                  stroke="#222222"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g id="Group">
                    <path
                      d="M9.6835903,1.36573713 L8.1949608,2.85398463 L7.14569467,2.85398463 L7.14569467,1.8046714 L8.63387538,0.315975093 C7.69245304,-0.198271091 6.53112145,-0.0766919494 5.71660488,0.621382477 C4.9020883,1.3194569 4.60414733,2.44853477 4.96817572,3.45763146 L0.326362363,8.09785792 C0.0448916766,8.37934124 -0.0650351397,8.78961211 0.0379902819,9.17412548 C0.141015704,9.55863884 0.441341351,9.85897797 0.825837459,9.96200801 C1.21033357,10.0650381 1.62058603,9.95510631 1.90205672,9.67362299 L6.54252371,5.03115249 C7.55157512,5.39519723 8.68060231,5.09724288 9.37864541,4.28268975 C10.0766885,3.46813662 10.1982622,2.30675291 9.68403909,1.36528832 L9.6835903,1.36573713 Z"
                      id="Path"
                    ></path>
                  </g>
                </g>
                <g
                  id="Overrides/Icons/Others/Ernährung"
                  transform={`translate(${t("mobile_descriptions.bottom_1.chef_hat_x")}, ${t(
                    "mobile_descriptions.bottom_1.chef_hat_y",
                  )})`}
                  stroke="#222222"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path
                    d="M8.80238099,1.37246198 C8.26025654,1.21760003 7.6750339,1.34538339 7.25110305,1.71118351 C6.98756518,0.704140134 6.06206349,0 5.00197228,0 C3.94188107,0 3.01637937,0.704140134 2.75284151,1.71118351 C2.32044101,1.34053238 1.72343193,1.21537014 1.1743079,1.38024582 C0.625183866,1.54512151 0.20193865,1.97661733 0.0552180597,2.52115083 C-0.0767942431,3.0121128 0.0308369482,3.53535946 0.346605768,3.93772573 C0.662374588,4.340092 1.15056751,4.57607017 1.66828042,4.57658457 C1.78077183,4.57231758 1.89250111,4.5565383 2.00164961,4.52950359 L2.00164961,8.34609743 C2.00164961,8.70723785 2.30015855,9 2.66838798,9 L7.33555657,9 C7.70378601,9 8.00229494,8.70723785 8.00229494,8.34609743 L8.00229494,4.52950359 C8.11144972,4.55650715 8.22317566,4.57228596 8.33566413,4.57658457 C9.1642166,4.5750779 9.86593084,3.97708196 9.98310605,3.17264614 C10.1002813,2.36821033 9.59736121,1.6014368 8.80238099,1.37246198 Z"
                    id="Path"
                  ></path>
                  <line x1="5.9128305" y1="7.35486277" x2="5.9128305" y2="5.34878656" id="Path"></line>
                  <line x1="4.094649" y1="7.35486277" x2="4.094649" y2="5.34878656" id="Path-Copy"></line>
                </g>
              </g>
              <g id="Group-3">
                <mask id="mask-6" fill="white">
                  <use href="#path-mobile-nutrient-explanation-5"></use>
                </mask>
                <g id="Rectangle"></g>
                <path
                  d="M24.7540142,580.017774 C23.8070142,579.817774 23.1570142,581.125774 24.0720142,581.637774 C25.4830142,582.426774 26.8940142,583.113774 28.3360142,583.721774 C14.163446,584.178138 0.238031841,588.804835 -11.2797773,596.96028 C-15.7125028,600.098971 -14.7624432,600.872519 -10.2576413,597.825817 C2.03441943,589.512412 16.5345794,585.079652 31.7320142,585.436774 C30.2800142,586.077774 28.8280142,586.718774 27.3760142,587.359774 C26.3220142,587.823774 27.2340142,589.369774 28.2810142,588.907774 C31.0020142,587.706774 33.7230142,586.505774 36.4440142,585.304774 C37.0280142,585.046774 37.0350142,584.011774 36.4440142,583.756774 C32.6500142,582.115774 28.8030142,580.872774 24.7540142,580.017774 Z"
                  id="Fill-1"
                  fill="#000000"
                  mask="url(#mask-6)"
                  transform="translate(11.361932, 589.875014) rotate(20.000000) translate(-11.361932, -589.875014) "
                ></path>
                <path
                  d="M24.7540142,670.017774 C23.8070142,669.817774 23.1570142,671.125774 24.0720142,671.637774 C25.4830142,672.426774 26.8940142,673.113774 28.3360142,673.721774 C14.163446,674.178138 0.238031841,678.804835 -11.2797773,686.96028 C-15.7125028,690.098971 -14.7624432,690.872519 -10.2576413,687.825817 C2.03441943,679.512412 16.5345794,675.079652 31.7320142,675.436774 C30.2800142,676.077774 28.8280142,676.718774 27.3760142,677.359774 C26.3220142,677.823774 27.2340142,679.369774 28.2810142,678.907774 C31.0020142,677.706774 33.7230142,676.505774 36.4440142,675.304774 C37.0280142,675.046774 37.0350142,674.011774 36.4440142,673.756774 C32.6500142,672.115774 28.8030142,670.872774 24.7540142,670.017774 Z"
                  id="Fill-1-Copy-4"
                  fill="#000000"
                  mask="url(#mask-6)"
                  transform="translate(11.361932, 679.875014) rotate(20.000000) translate(-11.361932, -679.875014) "
                ></path>
                <path
                  d="M24.7540142,157.017774 C23.8070142,156.817774 23.1570142,158.125774 24.0720142,158.637774 C25.4830142,159.426774 26.8940142,160.113774 28.3360142,160.721774 C14.163446,161.178138 0.238031841,165.804835 -11.2797773,173.96028 C-15.7125028,177.098971 -14.7624432,177.872519 -10.2576413,174.825817 C2.03441943,166.512412 16.5345794,162.079652 31.7320142,162.436774 C30.2800142,163.077774 28.8280142,163.718774 27.3760142,164.359774 C26.3220142,164.823774 27.2340142,166.369774 28.2810142,165.907774 C31.0020142,164.706774 33.7230142,163.505774 36.4440142,162.304774 C37.0280142,162.046774 37.0350142,161.011774 36.4440142,160.756774 C32.6500142,159.115774 28.8030142,157.872774 24.7540142,157.017774 Z"
                  id="Fill-1-Copy"
                  fill="#000000"
                  mask="url(#mask-6)"
                  transform="translate(11.361932, 166.875014) scale(-1, 1) rotate(20.000000) translate(-11.361932, -166.875014) "
                ></path>
                <path
                  d="M24.7540142,205.017774 C23.8070142,204.817774 23.1570142,206.125774 24.0720142,206.637774 C25.4830142,207.426774 26.8940142,208.113774 28.3360142,208.721774 C14.163446,209.178138 0.238031841,213.804835 -11.2797773,221.96028 C-15.7125028,225.098971 -14.7624432,225.872519 -10.2576413,222.825817 C2.03441943,214.512412 16.5345794,210.079652 31.7320142,210.436774 C30.2800142,211.077774 28.8280142,211.718774 27.3760142,212.359774 C26.3220142,212.823774 27.2340142,214.369774 28.2810142,213.907774 C31.0020142,212.706774 33.7230142,211.505774 36.4440142,210.304774 C37.0280142,210.046774 37.0350142,209.011774 36.4440142,208.756774 C32.6500142,207.115774 28.8030142,205.872774 24.7540142,205.017774 Z"
                  id="Fill-1-Copy-3"
                  fill="#000000"
                  mask="url(#mask-6)"
                  transform="translate(11.361932, 214.875014) scale(-1, 1) rotate(20.000000) translate(-11.361932, -214.875014) "
                ></path>
              </g>
              <path
                d="M119.039407,307.303 C118.053407,309.016 117.085407,310.741 116.114407,312.463 C113.660407,300.561 112.985407,288.482 113.355407,276.351 C113.370407,275.875 112.665407,275.889 112.624407,276.351 C111.657407,287.389 112.273407,298.352 113.896407,309.256 C113.173407,307.977 112.451407,306.697 111.725407,305.42 C111.236407,304.56 109.818407,305.132 110.112407,306.1 C111.182407,309.608 112.667407,312.615 114.845407,315.589 C115.219407,316.1 116.014407,316.212 116.365407,315.589 C117.758407,313.12 119.160407,310.656 120.533407,308.176 C121.072407,307.202 119.595407,306.336 119.039407,307.303"
                id="Fill-1"
                fill="#000000"
              ></path>
              <path
                d="M266.039407,307.303 C265.053407,309.016 264.085407,310.741 263.114407,312.463 C260.660407,300.561 259.985407,288.482 260.355407,276.351 C260.370407,275.875 259.665407,275.889 259.624407,276.351 C258.657407,287.389 259.273407,298.352 260.896407,309.256 C260.173407,307.977 259.451407,306.697 258.725407,305.42 C258.236407,304.56 256.818407,305.132 257.112407,306.1 C258.182407,309.608 259.667407,312.615 261.845407,315.589 C262.219407,316.1 263.014407,316.212 263.365407,315.589 C264.758407,313.12 266.160407,310.656 267.533407,308.176 C268.072407,307.202 266.595407,306.336 266.039407,307.303"
                id="Fill-1-Copy-2"
                fill="#000000"
                transform="translate(262.361233, 296.007256) scale(-1, 1) translate(-262.361233, -296.007256) "
              ></path>
              <text
                id="Hier-kannst-du-noch"
                fontFamily="Navigo-Light, Navigo"
                fontSize="14"
                fontWeight="300"
                line-spacing="19"
                fill="#222222"
              >
                <tspan x="173.015107" y="62">
                  {t("descriptions.top_right.line_1")}
                </tspan>
                <tspan x="173.015107" y="81">
                  {t("descriptions.top_right.line_2")}
                </tspan>
              </text>
              <path
                d="M323.311414,103.088491 C323.215414,102.948491 323.070414,102.848491 322.874414,102.813491 C320.754414,101.480491 318.634414,100.147491 316.514414,98.8134907 C315.534414,98.1974907 314.633414,99.7494907 315.609414,100.361491 C316.976414,101.220491 318.343414,102.079491 319.710414,102.937491 C310.586414,103.197491 301.463414,101.488491 292.814414,98.5994907 C286.209307,96.3930478 279.099025,91.9664914 276.156255,85.7053207 C275.678043,84.6878555 274.485747,84.6878555 275.248545,86.2543901 C277.528201,90.9360464 281.398814,94.9189968 286.098414,97.3574907 C296.058414,102.525491 308.398414,104.866491 319.719414,104.624491 C317.797414,105.890491 315.825414,107.056491 313.752414,108.114491 C312.841414,108.580491 313.484414,109.967491 314.433414,109.729491 C318.092414,108.814491 321.369414,107.425491 324.571414,105.424491 C325.150414,105.062491 325.147414,104.242491 324.571414,103.880491 C324.151414,103.616491 323.731414,103.352491 323.311414,103.088491 Z"
                id="Fill-1"
                fill="#000000"
                transform="translate(300.002270, 97.378283) scale(-1, 1) rotate(-90.000000) translate(-300.002270, -97.378283) "
              ></path>
              <text
                id="Um-diesen-Nährstoff"
                fontFamily="Navigo-Light, Navigo"
                fontSize="14"
                fontWeight="300"
                line-spacing="19"
                fill="#222222"
              >
                <tspan x="42.7440947" y="26">
                  {t("descriptions.top_center.line_1")}
                </tspan>
              </text>
              <path
                d="M106.008047,82.8271869 C108.345047,85.0821869 109.746047,88.1921869 108.985047,91.4701869 C107.828047,96.4461869 102.100047,97.6051869 98.6420466,94.0601869 C94.2760466,89.5841869 97.2530466,83.1671869 101.208047,79.4861869 C102.980047,80.3731869 104.606047,81.4741869 106.008047,82.8271869 M135.361047,72.0801869 C131.659047,69.5051869 127.748047,67.5271869 123.496047,66.0481869 C122.548047,65.7191869 121.970047,67.1651869 122.821047,67.6501869 C124.494047,68.6041869 126.187047,69.5041869 127.901047,70.3631869 C118.687047,69.8681869 107.035047,71.5431869 100.211047,77.7241869 C97.6480466,76.7591869 94.9300466,76.1601869 92.3850466,75.7951869 C76.2750466,73.4821869 62.9170466,82.4821869 51.9080466,93.2091869 C51.6330466,93.4771869 52.0430466,93.8771869 52.3250466,93.6271869 C59.5270466,87.2471869 67.1090466,80.8361869 76.5240466,78.0751869 C83.2490466,76.1021869 92.1580466,75.8351869 99.2770466,78.6321869 C97.8910466,80.0761869 96.7460466,81.7341869 95.9280466,83.6411869 C94.1110466,87.8841869 94.5580466,93.1851869 98.4390466,96.1031869 C101.618047,98.4931869 106.229047,98.5331869 108.854047,95.3291869 C111.886047,91.6271869 110.920047,86.1881869 107.971047,82.7911869 C106.418047,81.0031869 104.433047,79.6411869 102.256047,78.5971869 C102.409047,78.4781869 102.560047,78.3521869 102.713047,78.2431869 C111.086047,72.2701869 122.612047,70.9661869 132.520047,72.5391869 C132.617047,72.5541869 132.712047,72.5461869 132.804047,72.5301869 C132.985047,72.6461869 133.166047,72.7631869 133.346047,72.8821869 C131.679047,74.0261869 129.965047,74.8251869 127.969047,75.3931869 C126.870047,75.7061869 127.337047,77.4241869 128.442047,77.1081869 C131.160047,76.3321869 133.316047,75.2061869 135.540047,73.4721869 C136.027047,73.0931869 135.774047,72.3681869 135.361047,72.0801869"
                id="Fill-1"
                fill="#000000"
                transform="translate(93.811843, 81.911499) rotate(-90.000000) translate(-93.811843, -81.911499) "
              ></path>
              <g id="Group" transform="translate(185.926993, 326.000000)">
                <g id="Analyse" transform="translate(1.000000, 0.000000)">
                  <text
                    id="Das-Ergebnis-deiner"
                    fontFamily="Navigo-Light, Navigo"
                    fontSize="14"
                    fontWeight="300"
                    line-spacing="19"
                    fill="#222222"
                  >
                    <tspan
                      x="0"
                      y="16"
                      dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.top_right.line_1") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="35"
                      dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.top_right.line_2") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="54"
                      dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.top_right.line_3") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="73"
                      dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.top_right.line_4") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="92"
                      dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.top_right.line_5") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="111"
                      dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.top_right.line_6") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="130"
                      dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.top_right.line_7") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="149"
                      dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.top_right.line_8") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="168"
                      dangerouslySetInnerHTML={{ __html: t("mobile_descriptions.top_right.line_9") }}
                    ></tspan>
                  </text>
                  <circle
                    id="Oval-Copy"
                    stroke="#F6F6F6"
                    strokeWidth="2"
                    fill="#D2D2D2"
                    cx={t("mobile_descriptions.top_right.icon_1.cx")}
                    cy={t("mobile_descriptions.top_right.icon_1.cy")}
                    r="6"
                  ></circle>
                  <circle
                    id="Oval"
                    stroke="#F6F6F6"
                    strokeWidth="2"
                    fill="#911B58"
                    cx={t("mobile_descriptions.top_right.icon_2.cx")}
                    cy={t("mobile_descriptions.top_right.icon_2.cy")}
                    r="6"
                  ></circle>
                  <circle
                    id="Oval-Copy-2"
                    stroke="#F6F6F6"
                    strokeWidth="2"
                    fill="#82BECC"
                    cx={t("mobile_descriptions.top_right.icon_3.cx")}
                    cy={t("mobile_descriptions.top_right.icon_3.cy")}
                    r="6"
                  ></circle>
                </g>
                <text
                  id="Trend-fallend-Trend"
                  fontFamily="Navigo-Light, Navigo"
                  fontSize="14"
                  fontWeight="300"
                  line-spacing="19"
                  fill="#222222"
                >
                  <tspan x="20" y="203">
                    {t("descriptions.bottom_right.line_1")}
                  </tspan>
                  <tspan x="20" y="222">
                    {t("descriptions.bottom_right.line_2")}
                  </tspan>
                </text>
                <g id="Icons/Level/Blut/4" transform="translate(0.000000, 191.000000)">
                  <circle id="Oval" fill="#911B58" cx="7" cy="7" r="7"></circle>
                  <g
                    id="Group"
                    transform="translate(7.262500, 7.168876) scale(1, -1) translate(-7.262500, -7.168876) translate(4.375000, 4.375000)"
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.3125"
                  >
                    <path
                      d="M4.04278519,0.855555556 C4.04651852,0.92877037 4.04278519,1.10444444 4.04278519,1.17786667 C4.05044926,3.465029 3.10569893,6.03259853 0,5.52222222"
                      id="Path"
                    ></path>
                    <polyline id="Path" points="2.275 1.75 4.025 0 5.775 1.75"></polyline>
                  </g>
                </g>
                <g id="Icons/Level/Blut/4-Copy" transform="translate(0.000000, 210.000000)">
                  <circle id="Oval" fill="#82BECC" cx="7" cy="7" r="7"></circle>
                  <g
                    id="Group"
                    transform="translate(4.375000, 3.937500)"
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.3125"
                  >
                    <path
                      d="M4.04278519,0.855555556 C4.04651852,0.92877037 4.04278519,1.10444444 4.04278519,1.17786667 C4.05044926,3.465029 3.10569893,6.03259853 0,5.52222222"
                      id="Path"
                    ></path>
                    <polyline id="Path" points="2.275 1.75 4.025 0 5.775 1.75"></polyline>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
